


























import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class ProcessingIcon extends Vue {
  @Prop({ default: '104' }) readonly width?: string;
  @Prop({ default: '104' }) readonly height?: string;
  @Prop({ default: '#EC7100' }) readonly color?: string;
  @Prop({ default: '#FFECD4' }) readonly colorBackground?: string;
}
